<template>
  <MobileDesktopOnlyScreen v-if="isMobileBlocked" />
  <template v-else>
    <AppNotification/>
    <GlobalProvider>
      <component
        :is="layoutComponent"
        v-if="layoutComponent"
      >
        <RouterView :key="route.fullPath" />
      </component>
    </GlobalProvider>
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'
import EmbedLayout from '@/layouts/EmbedLayout.vue'
import GlobalProvider from '@/components/platform/GlobalProvider.vue'
import AppNotification from './components/platform/elements/AppNotification.vue'
import LoadingScreen from '@/components/app/LoadingScreen.vue'
import MobileDesktopOnlyScreen from '@/components/app/MobileDesktopOnlyScreen.vue'
import { useMobileDesktopOnlyBlocker } from '@/common/composables/useMobileDesktopOnlyBlocker'
import { useSettingsStore } from '@/stores'

const { isBlocked: isMobileBlocked } = useMobileDesktopOnlyBlocker()

const {setSettingsSync} = useSettingsStore()

setSettingsSync()

const route = useRoute()

const layoutComponent = computed(() => {
  const layoutName = route.meta?.layout as string || 'loading'

  const layouts = {
    default: DefaultLayout,
    auth: AuthLayout,
    empty: EmptyLayout,
    embed: EmbedLayout,
    loading: LoadingScreen
  }

  return layouts[layoutName as keyof typeof layouts] || LoadingScreen
})
</script>

<style>
/* Глобальные стили */
#app {
  font-family: 'Noto Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  min-height: inherit;
}

* {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
